var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgB737700(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 544.078,
    height: 301,
    viewBox: "0 0 544.078 301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AVION",
    transform: "translate(-808.112 -166.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398",
    transform: "translate(976.449 343.797)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M99.371,123.2S76.334,81.371,60.8,53.942c-3.82.832-18.644,3.95-28.076,4.339-10.893.451-26.783.735-32.687-4.542-.09-.053,0-23.573,0-23.573s1.91-2.342,8.812-3.154A130.949,130.949,0,0,1,45.3,28.387C32.911,12.093,15.621,0,15.621,0H125.935V31.131c.487.034,1.433.1,3.223.207,3.281.2,5.723,1.259,5.993,1.981s-5.175,2.615-5.175,2.615h-4.041v9.653l4.8,15.487c.1,0,2.766-.088,6.689,0,3.992.089,10.533,1.169,10.623,2.7s-9.535,3.6-9.535,3.6h-5.823l3.279,10.587L152.153,123.2Z",
    transform: "translate(-0.001)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M696.907,678.383s-4.112-.166-11.83-.438-22.971.091-26.24-3.451,4.812-4.54,12.621-5.175,18.432-.545,18.432-.545c.59,0,1.03.011,1.383.039.177.014.332.032.473.055h0l.008,0a3.725,3.725,0,0,1,.4.088,21.564,21.564,0,0,1,6.583,2.9h0a27.312,27.312,0,0,1,4.588,3.163C705.052,676.544,696.907,678.383,696.907,678.383Z",
    transform: "translate(-639.783 -632.594)",
    fill: "#003d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    transform: "translate(976.449 167)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M15.621,123.2s17.29-12.1,29.676-28.388A131.093,131.093,0,0,1,8.852,96.193C1.95,95.381.04,93.039.04,93.039s-.09-23.521,0-23.573c5.9-5.277,21.794-4.993,32.687-4.542,9.433.39,24.256,3.508,28.076,4.34C76.334,41.828,99.371,0,99.371,0h52.782L135.964,45.23l-3.28,10.591h5.824s9.625,2.074,9.535,3.6-6.631,2.614-10.623,2.7c-3.932.088-6.6,0-6.689,0l-4.8,15.487V87.27h4.041s5.448,1.892,5.175,2.614-2.712,1.782-5.993,1.981c-1.79.111-2.735.173-3.223.208V123.2Z",
    transform: "translate(-0.001 0)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M696.907,309.745s-4.112.166-11.83.439-22.971-.091-26.24,3.45,4.812,4.54,12.621,5.176,18.432.545,18.432.545c.59,0,1.03-.011,1.383-.039.177-.014.332-.032.473-.055h.008a3.83,3.83,0,0,0,.4-.088,21.577,21.577,0,0,0,6.583-2.9h0a27.305,27.305,0,0,0,4.588-3.163C705.052,311.584,696.907,309.745,696.907,309.745Z",
    transform: "translate(-639.783 -232.331)",
    fill: "#003d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399",
    transform: "translate(921.505 290.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 0.378,
    height: 0.945,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M464.092,486.66h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Z",
    transform: "translate(-463.714 -436.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 0.378,
    height: 0.945,
    transform: "translate(0 52.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    transform: "translate(958.757 290.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 0.378,
    height: 0.945,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M562.8,486.66h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Zm0-3.8h-.378v-1.9h.378Z",
    transform: "translate(-562.424 -436.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 0.378,
    height: 0.945,
    transform: "translate(0 52.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 0.378,
    height: 53.215,
    transform: "translate(1013.872 290.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 0.378,
    height: 53.215,
    transform: "translate(1078.109 290.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401",
    transform: "translate(894.938 316.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 1.513,
    height: 0.378,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M515.74,500.926h-2.983v-.378h2.983Zm-5.967,0H506.79v-.378h2.983Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0H488.89v-.378h2.983Zm-5.967,0h-2.983v-.378h2.983Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.983v-.378h2.983Zm-5.967,0h-2.983v-.378h2.983Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.983v-.378h2.983Zm-5.967,0h-2.983v-.378h2.983Zm-5.967,0h-2.984v-.378H432.2Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.984v-.378h2.984Zm-5.967,0h-2.984v-.378H414.3Zm-5.967,0h-2.984v-.378h2.984Z",
    transform: "translate(-400.858 -500.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 1.513,
    height: 0.378,
    transform: "translate(117.866 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M879.189,499.159v-.378a2.554,2.554,0,1,0,0-5.108V493.3a2.932,2.932,0,1,1,0,5.864Z",
    transform: "translate(199.105 -179.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M502.215,438.4H470.274v-6.794h.378v6.415h31.185v-6.415h.378Z",
    transform: "translate(453.69 -141.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    transform: "translate(935.391 292.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M500.523,437.636h.96c.8,0,1.156.559,1.156,1.361s-.385,1.342-1.183,1.342h-.934Zm.926,2.479c.646,0,.926-.435.926-1.119s-.253-1.138-.9-1.138h-.7v2.257Z",
    transform: "translate(-500.523 -437.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M506.843,438.892A1.267,1.267,0,1,1,508.1,440.3,1.277,1.277,0,0,1,506.843,438.892Zm2.253,0c0-.654-.348-1.18-1-1.18s-.99.526-.99,1.18.344,1.179.99,1.179S509.1,439.546,509.1,438.892Z",
    transform: "translate(-504.453 -437.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M514.223,438.892a1.266,1.266,0,1,1,1.255,1.406A1.277,1.277,0,0,1,514.223,438.892Zm2.253,0c0-.654-.348-1.18-1-1.18s-.99.526-.99,1.18.344,1.179.99,1.179S516.476,439.546,516.476,438.892Z",
    transform: "translate(-509.042 -437.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M521.883,437.636h1.206a.688.688,0,0,1,.767.729.612.612,0,0,1-.454.65v.011c.28.095.371.3.39.718.019.435.068.545.117.579v.015h-.272c-.061-.042-.076-.144-.1-.6s-.185-.6-.578-.6h-.824v1.206h-.253ZM523,438.917c.393,0,.593-.193.593-.529s-.151-.529-.559-.529h-.9v1.059Z",
    transform: "translate(-513.805 -437.579)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    transform: "translate(933.1 305.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M494.458,473.747a1.255,1.255,0,0,1,1.229-1.41.974.974,0,0,1,1.039.82h-.25a.748.748,0,0,0-.793-.6c-.635,0-.96.525-.96,1.19s.336,1.175.956,1.175a.821.821,0,0,0,.846-.809h.246a1.171,1.171,0,0,1-.28.707,1.058,1.058,0,0,1-.816.325A1.238,1.238,0,0,1,494.458,473.747Z",
    transform: "translate(-494.458 -472.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M501.229,473.743a1.266,1.266,0,1,1,1.255,1.406A1.277,1.277,0,0,1,501.229,473.743Zm2.252,0c0-.654-.348-1.179-1-1.179s-.99.525-.99,1.179.344,1.179.99,1.179S503.482,474.4,503.482,473.743Z",
    transform: "translate(-498.668 -472.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M508.888,472.487h.344l.933,2.359h.008l.911-2.359h.355v2.7h-.245v-2.355h-.008s-.072.216-.129.366l-.782,1.988h-.223l-.79-1.988c-.056-.14-.132-.366-.132-.366h-.008v2.355h-.234Z",
    transform: "translate(-503.431 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M516.918,472.487h1.062a.815.815,0,0,1,.635.234.727.727,0,0,1,.189.522c0,.5-.291.771-.858.771h-.775v1.175h-.253Zm1.009,1.312c.439,0,.62-.208.62-.548s-.208-.54-.6-.54h-.779V473.8Z",
    transform: "translate(-508.424 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M523.143,472.714h-.914v-.227h2.079v.227H523.4v2.476h-.253Z",
    transform: "translate(-511.726 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M527.389,478.764h.287v.329h-.287Z",
    transform: "translate(-514.935 -476.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M530.942,473.4H530.4v-.166c.382-.018.559-.105.6-.491h.185v2.6h-.246Z",
    transform: "translate(-516.806 -472.592)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(979.611 305.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M617.713,473.747a1.255,1.255,0,0,1,1.228-1.41.973.973,0,0,1,1.039.82h-.249a.748.748,0,0,0-.794-.6c-.635,0-.96.525-.96,1.19s.336,1.175.956,1.175a.821.821,0,0,0,.847-.809h.246a1.171,1.171,0,0,1-.28.707,1.06,1.06,0,0,1-.816.325A1.238,1.238,0,0,1,617.713,473.747Z",
    transform: "translate(-617.713 -472.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M624.483,473.743a1.266,1.266,0,1,1,1.255,1.406A1.277,1.277,0,0,1,624.483,473.743Zm2.253,0c0-.654-.348-1.179-1-1.179s-.99.525-.99,1.179.344,1.179.99,1.179S626.735,474.4,626.735,473.743Z",
    transform: "translate(-621.923 -472.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M632.143,472.487h.344l.934,2.359h.008l.911-2.359h.356v2.7h-.246v-2.355h-.008s-.072.216-.129.366l-.782,1.988h-.223l-.79-1.988c-.057-.14-.132-.366-.132-.366h-.008v2.355h-.234Z",
    transform: "translate(-626.686 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M640.172,472.487h1.062a.816.816,0,0,1,.635.234.729.729,0,0,1,.189.522c0,.5-.291.771-.858.771h-.775v1.175h-.253Zm1.009,1.312c.438,0,.62-.208.62-.548s-.208-.54-.6-.54h-.779V473.8Z",
    transform: "translate(-631.678 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M646.4,472.714h-.914v-.227h2.079v.227h-.911v2.476H646.4Z",
    transform: "translate(-634.981 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M650.643,478.764h.287v.329h-.287Z",
    transform: "translate(-638.189 -476.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M654.512,474.125c.352-.212.593-.34.593-.718a.514.514,0,0,0-.559-.552.566.566,0,0,0-.431.166.74.74,0,0,0-.163.51h-.25a.8.8,0,0,1,.858-.885.738.738,0,0,1,.794.752c0,.518-.371.7-.752.926-.3.178-.627.378-.68.737h1.4v.227h-1.678C653.654,474.624,654.1,474.371,654.512,474.125Z",
    transform: "translate(-640.055 -472.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405",
    transform: "translate(1123.455 305.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M998.9,473.747a1.255,1.255,0,0,1,1.228-1.41.973.973,0,0,1,1.039.82h-.249a.748.748,0,0,0-.793-.6c-.635,0-.96.525-.96,1.19s.336,1.175.956,1.175a.821.821,0,0,0,.847-.809h.246a1.171,1.171,0,0,1-.28.707,1.06,1.06,0,0,1-.817.325A1.238,1.238,0,0,1,998.9,473.747Z",
    transform: "translate(-998.9 -472.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M1005.67,473.743a1.266,1.266,0,1,1,1.255,1.406A1.277,1.277,0,0,1,1005.67,473.743Zm2.253,0c0-.654-.348-1.179-1-1.179s-.99.525-.99,1.179.344,1.179.99,1.179S1007.923,474.4,1007.923,473.743Z",
    transform: "translate(-1003.11 -472.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M1013.33,472.487h.344l.934,2.359h.008l.911-2.359h.355v2.7h-.245v-2.355h-.008s-.071.216-.129.366l-.782,1.988h-.223l-.79-1.988c-.057-.14-.132-.366-.132-.366h-.008v2.355h-.234Z",
    transform: "translate(-1007.873 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M1021.359,472.487h1.062a.815.815,0,0,1,.635.234.727.727,0,0,1,.189.522c0,.5-.291.771-.858.771h-.775v1.175h-.253Zm1.009,1.312c.439,0,.62-.208.62-.548s-.208-.54-.6-.54h-.779V473.8Z",
    transform: "translate(-1012.865 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M1027.585,472.714h-.915v-.227h2.079v.227h-.911v2.476h-.253Z",
    transform: "translate(-1016.168 -472.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M1031.83,478.764h.287v.329h-.287Z",
    transform: "translate(-1019.376 -476.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M1034.75,474.482H1035a.615.615,0,0,0,.669.639.548.548,0,0,0,.62-.567c0-.344-.234-.545-.639-.545h-.181v-.2h.177c.355,0,.556-.189.556-.48a.485.485,0,0,0-.537-.491.568.568,0,0,0-.586.62h-.242a.78.78,0,0,1,.835-.82.7.7,0,0,1,.771.692.569.569,0,0,1-.39.564v.011a.644.644,0,0,1,.484.669.771.771,0,0,1-.865.764A.847.847,0,0,1,1034.75,474.482Z",
    transform: "translate(-1021.192 -472.524)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406",
    transform: "translate(936.069 329.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M502.318,537.5a2.738,2.738,0,0,1,.518-1.584h.2a3.063,3.063,0,0,0-.453,1.584,3.257,3.257,0,0,0,.453,1.712h-.2A3.033,3.033,0,0,1,502.318,537.5Z",
    transform: "translate(-502.318 -535.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M505.068,536.3h.276l1.243,1.9c.136.2.268.446.268.446h.008V536.3h.242v2.7h-.265l-1.24-1.875c-.125-.189-.283-.458-.283-.458h-.008v2.332h-.242Z",
    transform: "translate(-504.028 -536.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M511.738,536.3h1.837v.223h-1.584v.972h1.451v.219h-1.451v1.055h1.625v.234h-1.878Z",
    transform: "translate(-508.175 -536.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M518.183,536.531h-.915V536.3h2.079v.227h-.911v2.476h-.253Z",
    transform: "translate(-511.614 -536.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M523.662,537.574a3.132,3.132,0,0,0-.454-1.659h.2a2.894,2.894,0,0,1,.522,1.659,2.841,2.841,0,0,1-.522,1.637h-.2A3.16,3.16,0,0,0,523.662,537.574Z",
    transform: "translate(-515.308 -535.915)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407",
    transform: "translate(1223.738 291.657)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 0.378,
    height: 0.945,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M1264.962,487.507h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378V458.23h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.952h.378Zm0-3.9h-.378v-1.951h.378Zm0-3.9h-.378v-1.952h.378Z",
    transform: "translate(-1264.584 -439.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 0.378,
    height: 0.945,
    transform: "translate(0 49.741)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408",
    transform: "translate(1080.428 316.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 1.513,
    height: 0.378,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M1098.406,500.926h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0H1077.5v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0H1035.7v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0H970v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0H958.06v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378H949.1Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0H928.2v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0h-2.986v-.378h2.986Zm-5.972,0H904.31v-.378H907.3Zm-5.972,0h-2.986v-.378h2.986Z",
    transform: "translate(-893.839 -500.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 1.513,
    height: 0.378,
    transform: "translate(207.553 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M1203.935,438.4h-31.941v-6.794h.378v6.415h31.185V432.7h.378Z",
    transform: "translate(16.753 -141.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M1344.158,445.341h-15.586v-6.233h.378v5.855h14.83V440.53h.378Z",
    transform: "translate(-80.713 -145.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409",
    transform: "translate(1200.121 292.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M1202.044,437.636h.96c.8,0,1.157.559,1.157,1.361s-.386,1.342-1.183,1.342h-.934Zm.926,2.479c.646,0,.926-.435.926-1.119s-.253-1.138-.9-1.138h-.7v2.257Z",
    transform: "translate(-1202.044 -437.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M1208.364,438.892a1.267,1.267,0,1,1,1.255,1.406A1.277,1.277,0,0,1,1208.364,438.892Zm2.252,0c0-.654-.347-1.18-1-1.18s-.991.526-.991,1.18.344,1.179.991,1.179S1210.616,439.546,1210.616,438.892Z",
    transform: "translate(-1205.974 -437.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M1215.744,438.892A1.266,1.266,0,1,1,1217,440.3,1.277,1.277,0,0,1,1215.744,438.892Zm2.252,0c0-.654-.347-1.18-1-1.18s-.991.526-.991,1.18.344,1.179.991,1.179S1218,439.546,1218,438.892Z",
    transform: "translate(-1210.563 -437.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M1223.4,437.636h1.206a.688.688,0,0,1,.767.729.612.612,0,0,1-.454.65v.011c.28.095.37.3.389.718.019.435.068.545.117.579v.015h-.272c-.061-.042-.076-.144-.1-.6s-.185-.6-.578-.6h-.824v1.206h-.253Zm1.119,1.281c.393,0,.593-.193.593-.529s-.151-.529-.559-.529h-.9v1.059Z",
    transform: "translate(-1215.325 -437.579)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    transform: "translate(1252.189 295.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M1340.618,444.218h1.837v.223h-1.584v.972h1.451v.219h-1.451v1.054h1.625v.234h-1.878Z",
    transform: "translate(-1340.618 -444.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M1346.118,445.478a1.255,1.255,0,0,1,1.229-1.41.973.973,0,0,1,1.04.82h-.25a.748.748,0,0,0-.794-.6c-.635,0-.96.526-.96,1.191s.336,1.175.956,1.175a.821.821,0,0,0,.846-.809h.246a1.169,1.169,0,0,1-.28.707,1.057,1.057,0,0,1-.816.325A1.238,1.238,0,0,1,1346.118,445.478Z",
    transform: "translate(-1344.038 -444.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M1353.088,446.062v-1.844h.253v1.822c0,.5.268.7.741.7.449,0,.737-.2.737-.7v-1.822h.253v1.844c0,.627-.416.9-1,.9S1353.088,446.682,1353.088,446.062Z",
    transform: "translate(-1348.372 -444.161)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    transform: "translate(1197.43 306.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M1194.93,474.747a1.255,1.255,0,0,1,1.228-1.41.973.973,0,0,1,1.039.82h-.249a.749.749,0,0,0-.794-.6c-.635,0-.96.525-.96,1.19s.337,1.175.956,1.175a.821.821,0,0,0,.847-.809h.246a1.174,1.174,0,0,1-.28.707,1.06,1.06,0,0,1-.817.325A1.238,1.238,0,0,1,1194.93,474.747Z",
    transform: "translate(-1194.93 -473.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M1201.7,474.743a1.266,1.266,0,1,1,1.255,1.406A1.277,1.277,0,0,1,1201.7,474.743Zm2.253,0c0-.654-.348-1.179-1-1.179s-.99.525-.99,1.179.344,1.179.99,1.179S1203.952,475.4,1203.952,474.743Z",
    transform: "translate(-1199.139 -473.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M1209.359,473.487h.344l.933,2.359h.008l.911-2.359h.355v2.7h-.245v-2.355h-.008s-.072.216-.129.366l-.783,1.988h-.223l-.79-1.988c-.057-.14-.132-.366-.132-.366h-.008v2.355h-.235Z",
    transform: "translate(-1203.902 -473.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M1217.389,473.487h1.062a.815.815,0,0,1,.635.234.727.727,0,0,1,.189.522c0,.5-.291.771-.858.771h-.775v1.175h-.253Zm1.009,1.312c.438,0,.619-.208.619-.548s-.208-.54-.6-.54h-.778V474.8Z",
    transform: "translate(-1208.896 -473.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M1223.614,473.714h-.915v-.227h2.079v.227h-.911v2.476h-.253Z",
    transform: "translate(-1212.197 -473.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M1227.859,479.764h.287v.329h-.287Z",
    transform: "translate(-1215.406 -477.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M1231.989,475.671h-1.21v-.227l1.243-1.728h.2v1.75h.4v.2h-.4v.661h-.238Zm0-.2v-1.338h-.008l-.956,1.326v.012Z",
    transform: "translate(-1217.221 -473.573)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412",
    transform: "translate(1202.684 330.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M1208.827,538.5a2.737,2.737,0,0,1,.518-1.584h.2a3.062,3.062,0,0,0-.453,1.584,3.257,3.257,0,0,0,.453,1.712h-.2A3.033,3.033,0,0,1,1208.827,538.5Z",
    transform: "translate(-1208.827 -536.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M1211.577,537.3h.276l1.244,1.9c.136.2.269.446.269.446h.007V537.3h.242v2.7h-.264l-1.24-1.875c-.125-.189-.284-.458-.284-.458h-.007v2.332h-.242Z",
    transform: "translate(-1210.537 -537.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M1218.247,537.3h1.837v.223H1218.5v.972h1.451v.219H1218.5v1.054h1.625v.234h-1.878Z",
    transform: "translate(-1214.685 -537.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M1224.691,537.531h-.914V537.3h2.079v.227h-.911v2.476h-.253Z",
    transform: "translate(-1218.123 -537.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M1230.171,538.574a3.133,3.133,0,0,0-.454-1.659h.2a2.9,2.9,0,0,1,.521,1.659,2.837,2.837,0,0,1-.521,1.636h-.2A3.158,3.158,0,0,0,1230.171,538.574Z",
    transform: "translate(-1221.817 -536.915)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(1244.115 330.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M1318.677,537.3h.261l.469,1.822c.053.2.125.533.125.533h.007s.076-.325.129-.518l.495-1.837h.272l.5,1.833c.049.193.125.522.125.522h.007s.076-.333.125-.533l.472-1.822h.253l-.733,2.7h-.257l-.514-1.969c-.049-.17-.106-.439-.106-.439h-.008s-.057.265-.1.439l-.53,1.969h-.269Z",
    transform: "translate(-1318.677 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M1327.856,537.3h.287l1.028,2.7h-.272l-.313-.851h-1.176l-.317.851h-.257Zm.654,1.644-.371-1.009c-.057-.151-.136-.393-.136-.393H1328s-.072.231-.132.393l-.378,1.009Z",
    transform: "translate(-1323.75 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M1333.227,539.043h.253a.74.74,0,0,0,.843.714c.4,0,.692-.2.692-.567,0-.382-.253-.473-.832-.59-.5-.1-.851-.249-.851-.722,0-.431.363-.714.9-.714a.849.849,0,0,1,.952.79h-.245a.636.636,0,0,0-.7-.578c-.412,0-.661.2-.661.495,0,.321.25.419.734.51.525.1.96.231.96.8,0,.48-.385.79-.953.79A.966.966,0,0,1,1333.227,539.043Z",
    transform: "translate(-1327.724 -537.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M1339.69,537.531h-.914V537.3h2.079v.227h-.911v2.476h-.253Z",
    transform: "translate(-1331.175 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M1345.1,537.3h1.837v.223h-1.584v.972h1.451v.219h-1.451v1.054h1.625v.234H1345.1Z",
    transform: "translate(-1335.11 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M1353.051,537.531h-.915V537.3h2.079v.227h-.911v2.476h-.253Z",
    transform: "translate(-1339.482 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M1358.077,537.3h.287l1.028,2.7h-.272l-.314-.851h-1.176l-.317.851h-.257Zm.654,1.644-.37-1.009c-.057-.151-.136-.393-.136-.393h-.008s-.072.231-.133.393l-.378,1.009Z",
    transform: "translate(-1342.542 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M1363.956,537.3h.276l1.243,1.9c.136.2.269.446.269.446h.007V537.3h.242v2.7h-.264l-1.24-1.875c-.125-.189-.284-.458-.284-.458h-.007v2.332h-.242Z",
    transform: "translate(-1346.832 -537.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M1370.626,537.3h.253v1.44l1.459-1.44h.329l-1.13,1.1,1.2,1.6h-.3l-1.07-1.429-.484.477v.952h-.253Z",
    transform: "translate(-1350.98 -537.252)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_24",
    "data-name": "Union 24",
    d: "M-14788.536-2396.377a5.442,5.442,0,0,1-4.622-2.692l-61.345-77.637c-4.076.558-9.325,1.188-16.065,1.857-24.818,2.464-58.869,3.85-73.919,3.909v0h-291.6v-.219c-7.921-.546-23.053-4.068-41.629-8.006-15.743-3.338-32.566-10.109-37.815-12.309l-1.561-.7c-2.327-1.019-4.907-2.888-4.907-5.56s2.669-4.453,4.961-5.556c0,0,20.522-9,39.472-13.02,18.458-3.911,33.512-7.41,41.479-7.994v-.227h291.6v0c15.05.059,49.1,1.445,73.919,3.909,6.8.673,12.082,1.308,16.173,1.873l61.237-77.56a5.442,5.442,0,0,1,4.622-2.692h9.443l-28.858,97.452a19.033,19.033,0,0,1,3.834,1.877v3.415a19.1,19.1,0,0,1-3.977,1.934l29,97.944Zm-447.08-74.937h290.752v-52.837h-290.6Zm291.129,0c7.92-.031,21.1-.433,35.431-1.163v-15.358l13.563-6.272h54.185v-21.8c-.25-.085-.915-.292-2.265-.6l-5.106-.98c-4.461-.746-11.379-1.7-21.927-2.75-24.8-2.464-58.836-3.85-73.88-3.909Zm35.812-16.279v15.1c12.782-.654,26.44-1.573,38.068-2.726,22.384-2.223,28.425-4.034,29.3-4.33v-14.174h-54.142Z",
    transform: "translate(16130.613 2814.736)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M265.779,460.417,255.1,461.951s-.245.553.859,1.35,1.657,1.35,3.56.982,6.26-1.473,6.26-1.473Z",
    transform: "translate(587.797 -159.062)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M265.779,535.439,255.1,533.9s-.245-.552.859-1.35,1.657-1.35,3.56-.982,6.26,1.473,6.26,1.473Z",
    transform: "translate(587.797 -203.37)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M240.4,471.207s-7.092,11.633,0,22.688c0-.166,4.994-1.437,4.994-1.437s-5.155-9.618,0-19.975Z",
    transform: "translate(598.881 -165.839)",
    fill: "#003d64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB737700);
export default __webpack_public_path__ + "static/media/b737-700.c7cd6ba9eb88839d456f35af378e6f88.svg";
export { ForwardRef as ReactComponent };